/* eslint-disable @trello/disallow-filenames */
export enum AtlassianAccountMigrationStage {
  done = 'done',
  ineligible = 'ineligible',
  newlyManaged = 'newlyManaged',
  migration = 'migration',
  migrationSuccess = 'migrationSuccess',
  enterpriseMigration = 'enterpriseMigration',
  inactiveMigration = 'inactiveMigration',
  emailHygiene = 'emailHygiene',
  confirmEmail = 'confirmEmail',
}
